export default __webpack_public_path__ + "static/media/brian.725b6954.jpeg";